import styles from '../../module/login/styles.module.css';

import {useEffect, useRef, useState} from 'react';
import Page from '../../component/Page';
import Panel from '../../component/Panel';
import { useAuth } from '../../module/auth/';
import {NavLink, useLocation, useNavigate} from 'react-router-dom';
import Input from '../../component/Input';
import Button from '../../component/Button';
import apiClient from '../../service/apiClient';
import LoginSidePanel from '../../component/LoginSidePanel';
import {useTranslation} from 'react-i18next';
import {SNACKBAR_TYPE_SUCCESS, SNACKBAR_TYPE_WARNING} from '../../component/Snackbar';
import {actions} from '../../component/Snackbar/slice';
import {useAppDispatch} from '../../module/redux/hooks';

const Login = () => {
    const { setAuth } = useAuth();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const navigate = useNavigate();
    const location = useLocation();

    const from = (location as CustomLocation).state?.from.pathname || '/';

    const loginRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        loginRef.current?.focus();

        if (from === '/settings/security') dispatch(actions.showSnackbar({type: SNACKBAR_TYPE_SUCCESS, message: t('password_update')}));
    }, []);

    const [login, setLogin] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    const handleSubmit = async (e: FixType) => {
        e.preventDefault();

        try {
            const user = await apiClient.login(login, password);

            // console.log(JSON.stringify(response));
            // const accessToken = response?.data?.accessToken;
            // const roles = response?.data?.roles;
            setAuth({
                user: null,
                roles: [user.role],
                accessToken: user.token,
            });
            setLogin('');
            setPassword('');
            navigate(from, { replace: true });
        } catch (err) {
            console.log(err);

            dispatch(actions.showSnackbar({type: SNACKBAR_TYPE_WARNING, message: 'Проверьте корректность данных'}));
            // if (!err?.response) {
            //     setErrMsg('No Server Response');
            // } else if (err.response?.status === 400) {
            //     setErrMsg('Missing Username or Password');
            // } else if (err.response?.status === 401) {
            //     setErrMsg('Unauthorized');
            // } else {
            //     setErrMsg('Login Failed');
            // }
            // errRef.current.focus();
        }

    };

    return (
        <Page title={t('entrance')}>
            <div className={styles.container}>
                <div className={styles.row}>
                    <LoginSidePanel />

                    <Panel title={t('sign_in')} isForm={true}>
                        <form onSubmit={handleSubmit}>
                            <Input className={`${styles.inputWrap} ${styles.inputWrapLogin}`} label={t('username')}>
                                <input
                                    type="text"
                                    required
                                    ref={loginRef}
                                    onChange={(e) => setLogin(e.target.value)}
                                />
                            </Input>
                            <Input className={`${styles.inputWrap} ${styles.inputWrapPassword}`} label={t('password')}>
                                <input
                                    type="password"
                                    required={true}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Input>

                            <div className={styles.actions}>
                                <NavLink className={styles.button} to={'/register'}>{t('register')}</NavLink>
                                <Button type="submit">{t('sign_in')}</Button>
                            </div>

                            <div className={styles.reset}>
                                <NavLink className={styles.resetLink} to={'/reset-password'}>{t('forgot_password')}</NavLink>
                            </div>
                        </form>
                    </Panel>
                </div>
            </div>
        </Page>
    );
};

export default Login;
